<template>
    <el-icon v-if="slots.default" :style="style">
        <slot></slot>
    </el-icon>
    <svg v-else aria-hidden="true" width="1em" height="1em" :style="style" :class="attrs.class">
        <use :xlink:href="`#${name}`" fill="currentColor" />
    </svg>
</template>
<script setup lang="ts">
import { computed, useAttrs, useSlots, type CSSProperties } from 'vue'
import { ElIcon } from 'element-plus';

defineOptions({ name: 'OIcon', inheritAttrs: false })

const { name } = defineProps<{ name: string }>()
const attrs = useAttrs()
const style = computed(() => {
    if (attrs.style) {
        return attrs.style as CSSProperties
    }
    return undefined
})
const slots = useSlots()
</script>